import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Link2 } from "lucide-react";

// Traceability badge on a Work Order: links back to the production order(s) that raised it.
export function SourceBadge({ wo, onOpenOrder }) {
  const sources = (wo.source_orders && wo.source_orders.length)
    ? wo.source_orders
    : (wo.source_order_code ? [{ code: wo.source_order_code, id: wo.source_order_id }] : []);
  if (!sources.length) return null;
  const open = (e, code) => { e.stopPropagation(); onOpenOrder && onOpenOrder(code); };
  if (sources.length === 1) {
    return (
      <button onClick={(e) => open(e, sources[0].code)} className="inline-flex items-center gap-1 text-[10px] text-indigo-600 hover:text-indigo-800 hover:underline font-mono-data" data-testid={`wo-source-${wo.order_code}`} title={`Open ${sources[0].code}`}>
        <Link2 className="h-3 w-3" /> for {sources[0].code}
      </button>
    );
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-1 text-[10px] text-indigo-600 hover:text-indigo-800 hover:underline font-mono-data" data-testid={`wo-source-${wo.order_code}`}>
          <Link2 className="h-3 w-3" /> for {sources.length} orders
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-52 p-2" align="start" data-testid={`wo-source-list-${wo.order_code}`}>
        <p className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold px-1 pb-1">Serves these orders</p>
        <div className="space-y-0.5">
          {sources.map((sc) => (
            <button key={sc.code} onClick={(e) => open(e, sc.code)} className="w-full text-left flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-mono-data text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 transition-colors" data-testid={`wo-source-item-${sc.code}`}>
              <Link2 className="h-3 w-3 shrink-0" /> {sc.code}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
